import React from "react";
import { useTranslation } from "react-i18next";

import Form from "../../../../forms/components/Form/Form";

export default function ArticleEditDates({ channel }) {
	const { t } = useTranslation();

	const supportsMetadata =
		!channel || !channel.acceptedDeliveryTypes?.length || channel.acceptedDeliveryTypes.includes("metadata");
	const supportsTakedown = supportsMetadata && !channel?.preventTakedown;

	const key = channel ? `channels.${channel.id}.` : "";

	return (
		<>
			{supportsMetadata && (
				<Form.DateInput
					name={`${key}announcementDate`}
					label={t("announcementDate", "Announcement date")}
					formatAs="yyyy-MM-dd"
					defaultValue={null}
				/>
			)}

			<Form.DateInput
				name={`${key}releaseDate`}
				label={t("releaseDate", "Release date")}
				formatAs="yyyy-MM-dd"
				defaultValue={null}
			/>

			{supportsTakedown && (
				<Form.DateInput
					name={`${key}takedownDate`}
					label={t("takedownDate", "Takedown date")}
					formatAs="yyyy-MM-dd"
					defaultValue={null}
				/>
			)}
		</>
	);
}
